export const GET_DEVICES_MDVR = "V3_GET_DEVICES_MDVR";
export const GET_DEVICES_MDVR_STATE = "V3_GET_DEVICES_MDVR_STATE";
export const CREATE_DEVICE_MDVR = 'V3_CREATE_DEVICE_MDVR'
export const UPDATE_DEVICE_MDVR = 'V3_UPDATE_DEVICE_MDVR'

export const GET_DEVICES_DISCONNECTED = 'V3_GET_DEVICES_DISCONNECTED' 
export const CLEAR_DEVICES_DISCONNECTED = 'V3_CLEAR_DEVICES_DISCONNECTED' 


// Passenger Count
export const GET_PASSENGER_COUNT = 'V3_GET_PASSENGER_COUNT'
export const GET_MDVR_EVENT = 'V3_GET_MDVR_EVENT'

export const UNSET_PASSENGER_COUNT = 'V3_UNSET_PASSENGER_COUNT'
export const UNSET_MDVR_EVENT = 'V3_UNSET_MDVR_EVENT'